<template>
	<div id="annMgmtBox">
		<div class="searchWrap">

			<div class="row queryRow">
				<div class="itemWrap keywordWrap">
					<el-input
						v-model="keyword"
						placeholder="輸入標題查詢"
						clearable
						@keyup.enter.native="doSearch"
                        style="min-width: 20rem;"
					></el-input>
                    <el-button type="primary" icon="el-icon-search" @click="doSearch" style="margin-left:1rem;">查詢</el-button>
				</div>

				<div class="itemWrap btnWrap">					
					<el-button type="success" icon="el-icon-plus" @click="openAddDialog">新增公告</el-button>
				</div>
			</div>
		</div>

		<div class="content">
			<el-table
				ref="multipleTable"
				border
				:cell-style="{ padding: '3px' }"
				:header-cell-style="{ background: '#FFF6EF', border: '1px #ddd solid', textAlign: 'center' }"
				style="width: 100%"
				empty-text="暫無數據"
				:data="tableData"
			>
				<el-table-column label="標題" prop="Title" min-width="10%"></el-table-column>
				<el-table-column label="內容" prop="Content" min-width="24%" show-overflow-tooltip></el-table-column>
				<el-table-column label="公告刊登起始時間" prop="PublishStartDt" min-width="12%">
					<template slot-scope="scope">{{ formatDateTime(scope.row.PublishStartDt) }}</template>
				</el-table-column>
				<el-table-column label="公告刊登結束時間" prop="PublishEndDt" min-width="12%">
					<template slot-scope="scope">{{ formatDateTime(scope.row.PublishEndDt) }}</template>
				</el-table-column>
				<el-table-column label="建立時間" prop="CreateDt" min-width="12%">
					<template slot-scope="scope">{{ formatDateTime(scope.row.CreateDt) }}</template>
				</el-table-column>
				<el-table-column label="最新修改時間" prop="ModifyDt" min-width="12%">
					<template slot-scope="scope">{{ formatDateTime(scope.row.ModifyDt) }}</template>
				</el-table-column>
				<el-table-column label="企業資訊" min-width="8%">
					<template slot-scope="scope">
						<el-button type="text" icon="el-icon-edit" @click="openEditDialog(scope.row)">編輯</el-button>
						<el-button type="text" icon="el-icon-delete" @click="deleteAnnouncement(scope.row)">刪除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<div class="pageBox">
			<Pagination
				@currentChange="pageChange"
				:pageSize="listQuery.Page_Size"
				:propsCurrentPage="listQuery.Page_Num"
				:totalLists="totalLists"
			></Pagination>
		</div>

		<el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="60%" center>
			<div class="dialogBox">
				<el-form ref="announcementForm" :model="formData" :rules="formRules" label-width="140px">
					<el-form-item label="公告標題" prop="Title">
						<el-input v-model="formData.Title" placeholder="請輸入公告標題" maxlength="200" show-word-limit></el-input>
					</el-form-item>

					<el-form-item label="公告內容" prop="Content">
						<el-input
							v-model="formData.Content"
							type="textarea"
							:rows="6"
							placeholder="請輸入公告內容"
						maxlength="500"
							show-word-limit
						></el-input>
					</el-form-item>

					<el-form-item label="公告刊登起始時間" prop="PublishStartDt">
						<el-date-picker
							v-model="formData.PublishStartDt"
							type="datetime"
							value-format="yyyy-MM-ddTHH:mm:ss"
							placeholder="請選擇起始時間"
							style="width: 100%"
						></el-date-picker>
					</el-form-item>

					<el-form-item label="公告刊登結束時間" prop="PublishEndDt">
						<el-date-picker
							v-model="formData.PublishEndDt"
							type="datetime"
							value-format="yyyy-MM-ddTHH:mm:ss"
							placeholder="請選擇結束時間"
							style="width: 100%"
						></el-date-picker>
					</el-form-item>
				</el-form>
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button type="primary" :loading="saving" @click="submitAnnouncement"><font-awesome-icon icon="plus" style="margin-right:5px;" />{{ dialogButton }}</el-button>
				<el-button type="danger" @click="dialogVisible = false" ><font-awesome-icon icon="times" style="margin-right:5px;" />關閉</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import Pagination from '../../components/Pagination.vue';
import { notify } from '@/utils/notify.js';

export default {
	components: {
		Pagination,
	},
	data() {
		const validateEndDate = (rule, value, callback) => {
			if (!value) {
				callback(new Error('請選擇公告刊登結束時間'));
				return;
			}
			if (this.formData.PublishStartDt && value <= this.formData.PublishStartDt) {
				callback(new Error('結束時間必須大於起始時間'));
				return;
			}
			callback();
		};

		const validateContent = (rule, value, callback) => {
			if (!value || value.trim() === '') {
				callback(new Error('請輸入公告內容'));
				return;
			}
			if (value.length > 500) {
				callback(new Error(`公告內容不可超過 500 字（目前 ${value.length} 字）`));
				return;
			}
			callback();
		};

		return {
			keyword: '',
			tableData: [],
			totalLists: 0,
			saving: false,

			listQuery: {
				Page_Size: 10,
				Page_Num: 1,
			},

			dialogVisible: false,
			dialogMode: 'add',
			currentRow: null,

			formData: {
				Title: '',
				Content: '',
				PublishStartDt: '',
				PublishEndDt: '',
			},

			formRules: {
				Title: [{ required: true, message: '請輸入公告標題', trigger: 'blur' }],
				Content: [{ required: true, validator: validateContent, trigger: 'blur' }],
				PublishStartDt: [{ required: true, message: '請選擇公告刊登起始時間', trigger: 'change' }],
				PublishEndDt: [{ required: true, validator: validateEndDate, trigger: 'change' }],
			},
		};
	},
	computed: {
		dialogTitle() {
			return this.dialogMode === 'edit' ? '編輯維護公告' : '新增維護公告';
		},
		dialogButton() {
			return this.dialogMode === 'edit' ? '儲存修改' : '新增';
		},
	},
	methods: {
		formatDateTime(value) {
			if (!value) return '';
			return String(value).replace('T', ' ').slice(0, 19);
		},

		buildSearchPayload() {
			const payload = {
				Page_Num: this.listQuery.Page_Num,
				Page_Size: this.listQuery.Page_Size,
			};
            if( this.keyword ) {
                payload.Keyword = this.keyword.trim();
            }

			return payload;
		},

		async getList() {
			this.$store.dispatch('loadingHandler', true);
			try {
				const payload = this.buildSearchPayload();
				const response = await this.$api.apiannoun.searchAnnouncement(payload);
				this.tableData = Array.isArray(response.data) ? response.data : [];
				this.totalLists = response.total || this.tableData.length;
			} catch (error) {
				notify({ title: '錯誤', message: '查詢公告失敗，請稍後再試', type: 'error' });
			} finally {
				this.$store.dispatch('loadingHandler', false);
			}
		},

		async doSearch() {
			this.listQuery.Page_Num = 1;
			await this.getList();
		},

		async pageChange(pageNum) {
			this.listQuery.Page_Num = pageNum;
			await this.getList();
		},

		resetForm() {
			this.formData = {
				Title: '',
				Content: '',
				PublishStartDt: '',
				PublishEndDt: '',
			};
			this.currentRow = null;
			this.$nextTick(() => {
				if (this.$refs.announcementForm) {
					this.$refs.announcementForm.clearValidate();
				}
			});
		},

		openAddDialog() {
			this.dialogMode = 'add';
			this.resetForm();
			this.dialogVisible = true;
		},

		openEditDialog(row) {
			this.dialogMode = 'edit';
			this.currentRow = row;
			this.formData = {
				Title: row.Title || '',
				Content: row.Content || '',
				PublishStartDt: this.normalizeDateTime(row.PublishStartDt),
				PublishEndDt: this.normalizeDateTime(row.PublishEndDt),
			};
			this.dialogVisible = true;
			this.$nextTick(() => {
				if (this.$refs.announcementForm) {
					this.$refs.announcementForm.clearValidate();
				}
			});
		},

		normalizeDateTime(value) {
			if (!value) return '';
			const text = String(value).replace(' ', 'T');
			return text.length > 19 ? text.slice(0, 19) : text;
		},

		resolveAnnouncementId(row) {
			return row.ID || row.AnnouncementID || row.AnnouncementId || row.id || null;
		},

		async submitAnnouncement() {
			if (!this.$refs.announcementForm) return;
			this.$refs.announcementForm.validate(async valid => {
				if (!valid) return;

				this.saving = true;
				const nowText = this.$dayjs ? this.$dayjs().format('YYYY-MM-DDTHH:mm:ss') : new Date().toISOString().slice(0, 19);
				const payload = {
					Title: this.formData.Title,
					Content: this.formData.Content,
					PublishStartDt: this.formData.PublishStartDt,
					PublishEndDt: this.formData.PublishEndDt,
					CreateDt: nowText,
					ModifyDt: nowText,
				};

				try {
					if (this.dialogMode === 'edit') {
						const id = this.resolveAnnouncementId(this.currentRow || {});
						await this.$api.apiannoun.updateAnnouncement({
							...payload,
							ID: id,
						});
						notify({ title: '成功', message: '公告更新成功', type: 'success' });
					} else {
						await this.$api.apiannoun.addAnnouncement(payload);
						notify({ title: '成功', message: '公告新增成功', type: 'success' });
					}

					this.dialogVisible = false;
					await this.getList();
				} catch (error) {
					notify({ title: '錯誤', message: '公告儲存失敗，請稍後再試', type: 'error' });
				} finally {
					this.saving = false;
				}
			});
		},

		deleteAnnouncement(row) {
			const id = this.resolveAnnouncementId(row);
			if (!id) {
				notify({ title: '錯誤', message: '找不到公告ID，無法刪除', type: 'error' });
				return;
			}

			this.$confirm(`確定要刪除「${row.Title || ''}」嗎？`, '提示', {
				confirmButtonText: '刪除',
				cancelButtonText: '取消',
				type: 'warning',
			}).then(async () => {
				try {
					await this.$api.apiannoun.deleteAnnouncement({ ID: id });
					notify({ title: '成功', message: '公告刪除成功', type: 'success' });
					if (this.tableData.length === 1 && this.listQuery.Page_Num > 1) {
						this.listQuery.Page_Num -= 1;
					}
					await this.getList();
				} catch (error) {
					notify({ title: '錯誤', message: '公告刪除失敗，請稍後再試', type: 'error' });
				}
			}).catch(() => {});
		},
	},

	async mounted() {
		await this.getList();
	},
};
</script>

<style lang="scss" scoped>
#annMgmtBox {
	background: linear-gradient(-135deg, #fff 20%, #fff 50%, transparent 50%) center center / 100% 100%;
	min-height: 100vh;
	padding: 0;

	.searchWrap {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		padding: 0 5%;

		.row {
			display: flex;
			flex-direction: row;
			justify-content: flex-start;
			margin-top: 10px;
		}

		.queryRow {
			align-items: center;
			gap: 12px;
			flex-wrap: wrap;
		}

		.itemWrap {
			display: flex;
			flex-direction: row;
			align-items: center;
			margin-bottom: 6px;
		}

		.titleWrap {
			width: 100%;
		}

		.pageTitle {
			background: #13a852;
			color: #fff;
			padding: 8px 20px;
			font-size: 16px;
			font-weight: bold;
		}

		.keywordWrap {
			width: 320px;
			max-width: 100%;
		}

		.btnWrap {
			margin-left: auto;
			gap: 10px;
		}
	}

	.content {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		padding: 0 5%;
		margin-top: 10px;
	}

	.pageBox {
		display: flex;
		justify-content: flex-end;
		padding: 0 5%;
		margin-top: 8px;
	}

	.dialogBox {
		padding: 0 15px;
	}
}
</style>
